import { get } from 'lodash-es';
import { useI18n } from 'vue-i18n';
import { FEATURE_FLAG, getFeatureFlag } from '@phoenix/helpers/feature-flag-helper';

// FIXME: I moved some existing logic here, but we should rethink this (and the getProductPriceForJson method)
// to only use the PriceHelper class directly in the backend
export const usePrice = () => {
  const { t } = useI18n();
  const hasPriceFeatureFlag = getFeatureFlag(FEATURE_FLAG.ECOM) || getFeatureFlag(FEATURE_FLAG.DISPLAY_PRICES);

  const localizedPrice = (price) => get(price, window.Phoenix.currentCountry);

  const localizedPriceDisplayValue = (price, shouldDisplayFromPrice = false, withHtmlTags = false) => {
    if (!hasPriceFeatureFlag || !price || price.priceOnDemand) {
      return t('Product.priceOnDemand');
    }

    const currencyClass = price.currency === '₽' ? 'text-system' : '';

    const currency = withHtmlTags
      ? `<span data-price="currency" class="${currencyClass}" data-cy="price-currency">${price.currency}</span>`
      : price.currency;

    const value = withHtmlTags ? `<span data-price="value">${price.text}</span>` : price.text;

    const formattedValue = price.shouldDisplayCurrencyFirst ? `${currency} ${value}` : `${value} ${currency}`;

    return shouldDisplayFromPrice ? t('Product.priceFrom', { price: formattedValue }) : formattedValue;
  };

  return {
    localizedPrice,
    localizedPriceDisplayValue,
  };
};
